import type { Replacements } from './shared/types';
import { replace as replaceBase } from './translate/replace';

export function replace(text: string, replacements: Replacements | undefined): string {
	return replaceBase('__CUSTOM_REPLACER__', text, replacements);
}
